import { jsx as s } from "@emotion/react/jsx-runtime";
import r, { cardClasses as e } from "@mui/material/Card";
import d, { cardActionsClasses as t } from "@mui/material/CardActions";
import C, { cardContentClasses as o } from "@mui/material/CardContent";
import n, { cardHeaderClasses as c } from "@mui/material/CardHeader";
import i, { cardMediaClasses as l } from "@mui/material/CardMedia";
const b = e, m = ({ ...a }) => /* @__PURE__ */ s(r, { ...a });
m.displayName = "Card";
const g = t, p = ({ ...a }) => /* @__PURE__ */ s(d, { ...a });
p.displayName = "CardActions";
const h = o, M = ({ ...a }) => /* @__PURE__ */ s(C, { ...a });
M.displayName = "CardContent";
const j = c, u = ({ ...a }) => /* @__PURE__ */ s(n, { ...a });
u.displayName = "CardHeader";
const k = l, f = ({ ...a }) => /* @__PURE__ */ s(i, { ...a });
f.displayName = "CardMedia";
export {
  m as C,
  g as a,
  p as b,
  b as c,
  h as d,
  M as e,
  j as f,
  u as g,
  k as h,
  f as i
};
